/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

import { cookieConsent } from '../lib/cookie.js';
import { getConfig } from '../lib/config.js';

export function init() {
        const uiText = getConfig()?.uiText?.cookie ?? {};

        // Suppress the auto-open when the user navigated to the map via one of
        // the consent links (imprint / privacy policy). Those links may be deep
        // links to a point on the map, and opening the cookie banner on top of
        // that navigation would be confusing.
        const suppressAutoOpen = (() => {
            const currentHash = window.location.hash;
            if (!currentHash) return false;
            return [uiText.links?.imprint, uiText.links?.privacyPolicy].some(
                (url) => {
                    if (!url) return false;
                    try {
                        return (
                            new URL(url, window.location.href).hash ===
                            currentHash
                        );
                    } catch (_) {
                        return false;
                    }
                }
            );
        })();

        const ui = {
            title: uiText.title,
            intro: uiText.introHtml,
            categories: [
                {
                    id: 'essential',
                    label: uiText.labels?.categories?.essential,
                    description: uiText.descriptions?.essential,
                    locked: true
                },
                {
                    id: 'statistics',
                    label: uiText.labels?.categories?.statistics,
                    description: uiText.descriptions?.statistics,
                    locked: false
                },
                {
                    id: 'external',
                    label: uiText.labels?.categories?.external,
                    description: uiText.descriptions?.external,
                    locked: false
                }
            ],
            labels: {
                saveSettings: uiText.labels?.saveSettings,
                acceptAll: uiText.labels?.acceptAll,
                acceptEssentialOnly: uiText.labels?.acceptEssentialOnly,
                imprint: uiText.labels?.imprint,
                privacyPolicy: uiText.labels?.privacyPolicy
            },
            urls: {
                imprint: uiText.links?.imprint,
                privacyPolicy: uiText.links?.privacyPolicy
            },
            suppressAutoOpen
        };
        cookieConsent.init(document.body, !!uiText.enabled, ui);
}
